/******************** TITLES ****************************/
export const SYSTEM_ERROR = "System Error";
export const ERROR_TYPE = "ERROR";
export const WARNING_TYPE = "Please review";
export const SERVER_WARNING_TYPE = "SERVER_WARNING_TYPE";
export const INFO_TYPE = "SUCCESS";
export const ERROR_DETAILS = "SERVER RESPONSE :";
export const NO_DATA_TITLE = "Looks like there’s no data to show";
export const ON_ERROR_TITLE = "Oops! Something went wrong";
export const UPDATE_WORKING_DOCUMENT_TITLE = "Update Working Document";
export const DELETE_WORKING_DOCUMENT_TITLE = "Delete Working Document";
export const CHECKIN_EXISTING_DOCUMENT_TITLE = "Check-in Existing Document";
export const DOCUMENT_DETAILS = "Document Details";
export const SUCCESS_TYPE = "SUCCESS";
/******************** TITLES ****************************/

/***************************** CONFIGURATION INFO TOOLTIPS ************************* */
export const CONFIGURATION_OR_OPERATOR_INFO_TOOLTIP =
  "The selected objects are combined using the OR operator.";
/***************************** End Of CONFIGURATION INFO TOOLTIPS ************************* */

/******************** SUCCESS MESSAGES ****************************/
export const CHECKIN_SUCCESS_TITLE = "Successfully checked-in";
export const DELETE_SUCCESS_TITLE = "Successfully deleted";
export const getSuccessMessage = (title, message) => {
  let successMessage = {
    type: SUCCESS_TYPE,
    title: title || DEFAULT_SUCCESS_TITLE,
    message: message || DEFAULT_SUCCESS_MESSAGE,
  };
  return successMessage;
};

export const DocumentCheckin = (documentTite) => {
  return `${documentTite} has been checked-in Successfully!`;
};
export const DocumentDelete = (documentTite) => {
  return `${documentTite} has been deleted Successfully!`;
};
/******************** ERROR MESSAGES ****************************/

/******************** ERROR MESSAGES ****************************/
export const VALIDATION_FAILED_ERROR =
  "Unable to proceed due to missing information. Please retry or contact the system administrator.";

/***************************** CHECK-IN FIELD VALIDATION MESSAGES ************************* */
export const CHECKIN_VALIDATION_TITLE_REQUIRED = "Title is required.";
export const CHECKIN_VALIDATION_CLASS_REQUIRED = "Class is required.";
export const CHECKIN_VALIDATION_FORMAT_REQUIRED = "Format is required.";
export const CHECKIN_VALIDATION_VIEW_COPY_REQUIRED = "View copy is required.";
export const CHECKIN_VALIDATION_OBJECT_CONNECTION_REQUIRED =
  "Object Connection(s) required.";
export const CHECKIN_VALIDATION_DOCUMENT_REQUIRED = "Document is required.";
export const CHECKIN_VALIDATION_NEW_REVISION_REQUIRED =
  "New revision is required.";
export const CHECKIN_VALIDATION_REVISION_TEXT_REQUIRED =
  "Revision text is required.";
export const CHECKIN_VALIDATION_NEW_REVISION_MAX_LENGTH =
  "The maximum character limit is 6";
/***************************** END CHECK-IN FIELD VALIDATION MESSAGES ************************* */

export const IFS_SERVER_ERROR =
  "An unexpected response from IFS server. Please try again later.";
export const EXCEPTION_ERROR =
  "Unexpected system error. Please refresh or try again later.";
export const ONEDRIVE_DATA_NOT_FOUND =
  "Unable to access file: The OneDrive file may be missing or corrupted.";
export const ONEDRIVE_DOC_LOCKED_MESSAGE = "OneDrive deletion failed";
export const ONEDRIVE_DOCUMENT_LOCKED_ERROR =
  "The document is locked because it is currently in use. Please close it and try again.";
export const TEMPLATE_DOWNLOAD_LOCKED_ERROR =
  "Download failed because the template is still open. Please close it and try again.";
/******************** ERROR MESSAGES ****************************/

/***************************** SERVER WARNING MESSAGES ************************* */
export const CHECKED_OUT_ALREADY = "Checked out Already";
export const CHECKED_OUT_ALREADY_MESSAGE =
  "This Document is already check - out";
/***************************** End Of SERVER WARNING MESSAGES ************************* */

/***************************** TOAST MESSAGES ************************* */
export const DEFAULT_SUCCESS_TITLE = "Completed!";
export const DEFAULT_SUCCESS_MESSAGE =
  "Your request was completed successfully.";

/***************************** End Of TOAST MESSAGES ************************* */

/***************************** NO DATA MESSAGES ************************* */
export const WORKING_DOCUMENTS_NO_DATA = "No documents to display yet.";
export const WORKING_DOCUMENTS_NO_DATA_SUB =
  "Go to All Documents to add documents here.";
export const WORKING_DOCUMENT_NO_DATA =
  "The documents may have been deleted or are no longer valid. Please verify in IFS.";
export const IFS_DOCUMENT_NO_DATA =
  "We couldn’t find any records for this document in IFS. It may have been removed. Please verify in IFS.";
/***************************** NO DATA MESSAGES ************************* */

/***************************** DOCUMENT PANEL INFO TOOLTIPS ************************* */
export const DOCUMENT_PANEL_WORKING_DOCS_INFO_GENERAL =
  "Documents you have checked out or downloaded from IFS. Ready to be checked in after modifications.";
export const DOCUMENT_PANEL_ALL_DOCS_INFO_GENERAL =
  "Documents available in IFS. By default, only documents you are involved in are shown. Change the filters to view more documents.";
export const DOCUMENT_PANEL_TEMPLATES_INFO = "Document templates available in IFS.";
export const DOCUMENT_PANEL_CHECKIN_NEW_INFO_GENERAL =
  "Documents stored in your OneDrive and ready to be checked into IFS.";
export const DOCUMENT_PANEL_WORKING_DOCS_INFO_CHANNEL =
  `Documents you have checked out or downloaded from IFS within the channel. Ready to be checked in after modifications. Also accessible via the "Shared" tab in the Teams channel.`;
export const DOCUMENT_PANEL_ALL_DOCS_INFO_CHANNEL =
  "Documents in IFS, connected to the objects defined in the channel configuration. By default, only documents you are involved in are shown. Change the filters to view more documents.";
export const DOCUMENT_PANEL_CHECKIN_NEW_INFO_CHANNEL =
  "Documents shared in the Teams channel and ready to be checked into IFS.";
/***************************** End Of DOCUMENT PANEL INFO TOOLTIPS ************************* */

/***************************** STATUS MESSAGES ************************* */
export const LOADING_IFS_DOCUMENT = "Loading documents from IFS";
export const DOWNLOAD_FROM_ONEDRIVE = "Fetching data from OneDrive";
export const DOWNLOADING_DOCUMENT = "Downloading document..";
export const DOWNLOAD_PENDING_MESSAGE = "Downloading document..";
export const DOWNLOAD_SUCCESS_MESSAGE = "Successfully downloaded";
export const CHECKIN_IFS_DOCUMENT = "Check-in the document to IFS";
export const DELETE_DOCUMENT_FROM_ONEDRIVE = "Deleting data from OneDrive";
export const UPLOADING_DOCUMENT_TO_ONEDRIVE =
  "Updating the working document in OneDrive";
export const PLEASE_WAIT = "Please, wait…";
export const CHECKOUTING_DOCUMENT = "Check-out in progress...";
export const UNDO_CHECKOUT_PENDING = "Undo check-out in progress...";
export const UNDO_CHECKOUT_DELETE_PENDING =
  "Undoing check-out and deleting from OneDrive…";
export const CHECKOUT_SUCCESS_MESSAGE = "Successfully checked out";
export const UNDO_CHECKOUT_SUCCESS_MESSAGE = "Document undo check-out successfully!";

export function formatBulkCheckoutToastMessage(
  successCount,
  failureCount = 0,
  skippedCount = 0,
) {
  const succeeded = Number(successCount) || 0;
  const failed = Number(failureCount) || 0;
  const skipped = Number(skippedCount) || 0;
  const parts = [`${succeeded} document(s) checked out successfully`];
  if (skipped > 0) {
    parts.push(`${skipped} skipped (Released or already checked out)`);
  }
  if (failed > 0) {
    parts.push(`${failed} failed`);
  }
  return `${parts.join(". ")}.`;
}

export function formatBulkUndoCheckoutToastMessage(
  successCount,
  failureCount = 0,
  skippedCount = 0,
) {
  const succeeded = Number(successCount) || 0;
  const failed = Number(failureCount) || 0;
  const skipped = Number(skippedCount) || 0;
  const parts = [`${succeeded} document(s) undo check-out successfully`];
  if (skipped > 0) {
    parts.push(`${skipped} skipped (Released or not checked out)`);
  }
  if (failed > 0) {
    parts.push(`${failed} failed`);
  }
  return `${parts.join(". ")}.`;
}

export const CHECKOUT_ERROR_MESSAGE =
  "Check-out failed. Please try again.";
export const CHECKOUT_ONEDRIVE_UPLOAD_FAILED_MESSAGE =
  "The document was checked out in IFS, but copying it to Working Documents failed (this can happen with very large files). Open Working Documents after a moment, use Download from All Documents, or undo check-out and try again.";
export const UNDO_CHECKOUT_ERROR_MESSAGE =
  "Undo check-out failed. Please try again.";
/***************************** End of STATUS MESSAGES ************************* */
export const PRODUCT_NAME = "Addovation Share Document Management";

export const EMPTY_RESULTS = "No documents to display.";
export const FAILED_TO_DOWNLOAD =
  "Failed to download the file. Please try again later.";
export const FAILED_TO_OVERWRITE = "Unable to Overwrite the file.";
export const FAILED_TO_CREATE_PDF =
  "Failed to create the PDF. Please try again later.";
export const FAILED_TO_MERGE_PDF =
  "Failed to merge the PDF. Please try again later.";
export const FAILED_COPY_ONDRIVE =
  "Failed to get the Onedrive link. Please try again later.";
export const FAILED_GENERATE_DIRECT_LINK =
  "Failed to get the link. Please try again later.";
export const FAILED_LOAD_DATA =
  "Failed to load data. Please hit Refresh button to try again.";
export const SEARCH_RESULT_FAILED =
  "Your search cannot be processed now due to some technical issue. Please try again later.";

export const IFS_DOCUMENT_LOAD_ERROR =
  "There is no object defined in the channel description to fetch documents for. Please check the channel description.";

/** Shown when the Teams channel has no description (Graph); object connections normally come from that text. */
export const CHANNEL_DESCRIPTION_MISSING_WARNING =
  "This channel is missing an connection(s) to an object in IFS. Please add them in 'Configuration' section or under 'Channel description'.";
export const GENERAL_CHANNEL_WARNING = "This channel is not supported for Addovation Share. Please create or select another channel and try again.";
export const ONEDRIVE_DOCUMENT_LOAD_ERROR =
  "Please check the one drive connection.";
export const WORKING_DOCUMENT_LOAD_ERROR =
  "Failed to load documents. Please hit Refresh button to try again.";
export const PAGINATION_ERROR = "Pagination Error: Could not load data.";
export const SERVER_RESPONSE_ISSUE =
  "The server response wasn’t what we expected.";
export const BAD_REQUEST_ERROR =
  "Oops! Something went wrong. Please try again.";
export const BAD_REQUEST_RESPONSE_ERROR =
  "Invalid or missing details in the request.";
export const SERVER_ERROR = "Oops! We couldn’t find your subscription.";
export const SERVER_RESPONSE_ERROR =
  "The request to the server failed or timed out.";
export const UNKOWN_ERROR =
  "An unknown error has occured.  Please contact your system administrator.";
export const INVALID_FILE_DATA =
  "The file is empty. Please check the document revision and try again.";
export const NO_CONTENT_FOUND =
  "We could not find any file content. Please try again ";
export const SELECTED_DOCUMENTS_DOWNLOAD_FAILED =
  "Failed to download the selected documents. Please try again later.";
export const SELECTED_DOCUMENTS_UPLOAD_FAILED =
  "Something went wrong while uploading your documents. Please try again in a moment.";
export const SESSION_EXPIRED =
  "Your session has expired. Please wait while you are redirected to the sign-in.";
export const AUTHORIZATION_FAIL =
  "Authorization Failed.  Please wait while you are redirected to the sign-in.";
export const LOGINURL_FAILED =
  "Unexpected error occurred while receiving login information. Please try again or contact your system administrator.";
export const GRAPH_SERVICE_ERROR =
  "You do not have permission to perform this action. Please contact your system administrator.";
export const NO_CLASSFORMAT_FOUND =
  "We could not find any related data. Please try again ";
export const NO_DOCBASICDATA_FOUND =
  "We could not find documeent basic data. Please try again ";
export const NO_LOGICALUNIT_FOUND =
  "No results available.";
export const NO_DEFAULT_OBJECTS_FOUND =
  "We could not find any related object connection. Please check your defined object connection or connect it using advanced object connection search.";
export const FAILED_LOGICALUNIT_FOUND =
  "Failed to get object connection basic data. Please try again ";
export const DOCUMENT_BASIC_DATA_ERROR =
  "We could not load the document details due to a technical issue. Please refresh the page and try again.";
export const DOCUMENT_LOGICAL_UNITS_ERROR =
  "We could not load the object connections due to a technical issue. Please refresh the page and try again.";
export const RECENT_OBJECT_DATA_ERROR =
  "We could not load the recent object data due to a technical issue. Please refresh the page and try again.";
export const ADVANCED_SEARCH_COLUMNS_ERROR =
  "We could not load the advanced search filters due to a technical issue. Please refresh the page and try again.";
export const ADVANCED_SEARCH_RESULTS_ERROR =
  "We could not load the advanced search results due to a technical issue. Please refresh the page and try again.";
export const ADVANCED_SEARCH_FIELD_HELP_TOOLTIP = [
  "Text fields support partial text searches.",
  "Number fields require an exact numeric value.",
];
export const ADVANCED_SEARCH_PLACEHOLDER_TEXT = "Search text";
export const ADVANCED_SEARCH_PLACEHOLDER_NUMBER = "Search number";
export const ADVANCED_SEARCH_TOOLTIP_TEXT = "Search for any text";
export const ADVANCED_SEARCH_TOOLTIP_NUMBER = "Search for exact number";
export const NEW_REVISION_INFO_ERROR =
  "We could not load the new revision information due to a technical issue. Please refresh the page and try again.";
export const FAILED_TO_GET_CLASSFORMAT =
  "Failed to load Classes and Formats due to technical error. Please try again ";
export const UPLOAD_SUCCESS = "Successfully uploaded";
export const VIEW_DOCUMENT_ERROR =
  "Either document is empty or you need permission to preform this action.";
export const SOME_DOCUMENT_ERROR =
  "Some documents have failed to process due to some technical errors.";
export const EMPTY_ACCESS_DENIED =
  "The document is no longer available or You do not have permission to access this document.";
export const CHECKOUT_NOT_FOUND =
  'Couldn’t to complete "Checkout" for the selected document. Please try again later.';
export const UNDOCHECKOUT_NOT_FOUND =
  'Couldn’t to complete "Undo Checkout" for the selected document. Please try again later.';
export const PREVIEW_NOT_FOUND =
  'Couldn’t to complete "Preview document" for the selected document. Please try again later.';
export const REDIRECT_TO_ONEDRIVE_SINGIN =
  "Redirecting to sign with your OneDrive Account";
export const NO_REVISION_FOUND =
  "We could not find any revision information. Please try again ";

export const CREATE_REVISION_FAILED =
  "Failed to create new revision. Please try again or contact your system administrator.";
export const CREATE_DOCUMENT_FAILED =
  "Failed to create new document. Please try again or contact your system administrator.";
export const CREATE_VIECOPY_FAILED =
  "Failed to create view copy. Please try again or contact your system administrator.";
export const CREATE_VIECOPY_FAILED_TITLE = "Unable to create View Copy";
export const FAILED_REVISION_INFO =
  "Failed to get revision information. Please try again or contact your system administrator.";
export const FAILED_RECENT_OBJECTS =
  "Failed to get recent object connections. Please try again or contact your system administrator.";
export const FAILED_OBJECT_COLUMNS =
  "Failed to get object columns. Please try again or contact your system administrator.";
export const FAILED_CHECK_OUT =
  "Failed to check out document. Please try again or contact your system administrator.";
export const FAILED_UNDO_CHECK_OUT =
  "Failed to undo check out document. Please try again or contact your system administrator.";
export const FAILED_PREVIEW_DOC =
  "Failed Preview document. Please try again or contact your system administrator.";
export const DOCUMENT_CHECKED_OUT = "check-out document";
export const DOCUMENT_RELEASED = "Released document";
export const CHECK_OUT_WARNING =
  "Failed to retrieve document revision information because this document is already checked out.";
export const NOT_CHECK_OUT_WARNING =
  "Failed to retrieve document revision information because this document is not checked out.";
export const RELEASED_WARNING =
  "Failed to retrieve document revision information because this document is already released.";
export const PREVIEW_URL_EMPTY = "Document Loading....";
export const PREVIEW_URL_ERROR = "Document issue";
export const PREVIEW_LOADING_IFS = "Uploading document to Teams…";
export const PREVIEW_LOADING_ONEDRIVE = "Loading preview…";
export const PREVIEW_LOADING_PREPARING = "Preparing preview…";

export const NO_USER_ACCOUNT =
  "User account not found. Please verify the information and try again.";
export const NO_USER_ACCOUNT_ERROR =
  "We couldn't find any account details for this request.";
export const INVALID_CONFIGURATION =
  "Configuration values that do not meet the required format or criteria";
export const MISSING_TEAMS_CONTEXT =
  "Teams context is missing (tenantId and UPN are empty). Please open this app in Microsoft Teams.";
export const INACTIVE_USER =
  "Your account might be inactive. Please contact your administrator";
export const UNAUTHORIZED_USER = "Please check your credentials and try again.";
export const IFS_UNAUTHORIZED_USER =
  "Unauthorized: IFS failed or access denied.";
export const UNAUTHORIZED_USER_MESSAGE =
  "Please contact your administrator and check your account status.";
export const FORBIDDEN =
  "Looks like you need permission. Please contact your administrator.";
export const AUTHENTICATION_FAIL_UNKNOWN =
  "Failed to authenticate your user. Please retry and sign-in again.";
export const IFS_AUTHENTICATION_FAIL_UNKNOWN =
  "Failed to authenticate your IFS user. Please reload the app.";
export const AUTHENTICATION_FAIL =
  "The system was unable to authenticate the user";
export const IFS_ACCESS_DENIED =
  "IFS Access Denied. Please contact your system administrator.";
export const IFS_AUTHENTICATE_FAILED =
  "This user account does not have access to the IFS environment";
export const IFS_TOKEN_EXPIRED =
  "Your session has expired. Please sign in again to continue.";
/** Shown when the same API keeps returning 401 after IFS refresh retries; user is sent back to login. */
export const IFS_401_RETRY_EXHAUSTED =
  "This request failed authorization repeatedly. Please sign in again from the login page.";
export const IFS_AUTHENTICATE =
  "Please wait while your user account is being authenticated in the IFS environment.";
export const UPLOAD_TO_ONEDRIVE = "Copying to Teams Channel Files";
export const TOKEN_FAILURE =
  "Authentication failed due to a token generation error.";
export const TEAMS_TOKEN_FAILURE =
  "Authentication failed: Unable to generate Microsoft Teams token.";
export const LU_FEILD_FAILD_MAIN = "Channel Configuration Required";
export const LU_FEILD_FAILD_SUB =
  "This channel is not properly configured. Please review and update the settings to continue.";
export const NO_LOGICALUNIT_FOUND_MAIN =
  "Sorry, no result found for your search!";
export const NO_LOGICALUNIT_FOUND_SUB =
  "Please try searching for something different.";

export const IFS_USER_ACCESS_DENIED =
  "We couldn’t log you in. Please try again.";
export const IFS_USER_AUTHENTICATION_FAILURE =
  "Failed to authenticate IFS account. Please try again.";
export const AZURE_USER_ACCESS_DENIED =
  "Your Microsoft account couldn’t be authenticated.";
export const AZURE_USER_AUTHENTICATION_FAILURE =
  "Failed to authenticate Microsoft account. Please try again.";
/** Same copy as Office add-in (TokenManager 13007) — user-facing Microsoft identity prompt. */
export const MICROSOFT_ACCOUNT_ISSUE_MESSAGE =
  "Error: There was an issue with your Microsoft Office account. Please verify your login and try again.";
export const OVERWRITE_DOCUMENT_CONFIRMATION_MSG =
  "This document already exists in OneDrive. Continuing will overwrite the version. Do you want to proceed?";
export const OVERWRITE_TEMPLATE_CONFIRMATION_MSG =
  "This template already exists in OneDrive and will be overwritten. If it is currently open, please close it before confirming. Do you want to proceed?";
export const OVERWRITE_DOCUMENT_CONFIRMATION_TITLE = "Overwrite Existing File";

export const DELETE_DOCUMENT_TITLE = "Delete from OneDrive";
export const DELETE_DOCUMENT_SUB_TITLE =
  "Are you sure you want to delete the selected document from OneDrive?";
export const getDeleteDocumentConfirmation = (documentTitle) => {
  return `Are you sure you want to delete the document "${documentTitle}" from OneDrive?`;
};
export const UNDO_CHECKOUT_DELETE_CONFIRMATION_TITLE =
  "Undo Check-out & Delete from OneDrive";
export const getUndoCheckoutDeleteConfirmation = (documentTitle) => {
  const title = String(documentTitle ?? "").trim() || "this document";
  return `Are you sure you want to undo check-out & delete "${title}" from OneDrive?`;
};
/** Message shown in dialog when delete fails */
export const DELETE_FAILED_MESSAGE = "Failed to delete the document from OneDrive. Please try again.";
export const getBulkDeleteConfirmation = (count) => {
  const documentsLabel = count === 1 ? "document" : "documents";
  return `Delete ${count} selected ${documentsLabel} from OneDrive?\n\nThis action permanently removes the selected ${documentsLabel}.`;
};
export const getBulkDeleteSuccessMessage = (count) =>
  `Successfully deleted ${count} ${count === 1 ? "document" : "documents"}.`;
export const getBulkDeletePartialMessage = (deletedCount, totalCount) => {
  const failedCount = Math.max(totalCount - deletedCount, 0);
  return `Deleted ${deletedCount} of ${totalCount} documents. ${failedCount} ${failedCount === 1 ? "document could" : "documents could"} not be deleted.`;
};
export const BULK_DELETE_FAILURE_MESSAGE =
  "Failed to delete the selected documents.";

export const DELETE_FILE = "file deletion";
export const CHECKIN_VIEWCOPY = "upload view copy";
export const CHECKIN_NEW_TIME_OUT = "The session has expired, or the selected file may be corrupted. Please refresh and try again";
export const getFileTypeMismatchError = () => {
  return `The file type is not supported in IFS. Please select a different file.`;
};

export const getUndoCheckoutSuccessMessage = (documentTitle) => {
    const title = String(documentTitle ?? "").trim();
    if (!title) return UNDO_CHECKOUT_SUCCESS_MESSAGE;
    return `${title} undo check-out successfully!`;
};
